import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { PresConceptosEditComponent } from '../pres-conceptos-edit/pres-conceptos-edit.component';

@Component({
  selector: 'app-pres-conceptos',
  templateUrl: './pres-conceptos.component.html',
  styleUrls: ['./pres-conceptos.component.css'],
  providers:[
    { provide: MatDialogRef,useValue: {} }
  ]
})
export class PresConceptosComponent implements OnInit {
  errMsg:any;
  arrArbol:any=[];
  arbol:any=[];

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<PresConceptosEditComponent>, public dialog: MatDialog) { }

  ngOnInit() {
    this.dataService.getPres_Arbol(3, '1,0', null).subscribe(
                      rows => {   
                              this.arrArbol = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnArbolCargado());
  }

  fnArbolCargado(){
    console.log(this.arrArbol)
    this.arbol = [];
    this.arbol.push({'tipo':'INGRESO',
                     'conceptos':[],
                     'ver': true,
                     'total':0
                    },{'tipo':'EGRESO',
                     'conceptos':[],
                     'ver': true,
                     'total':0
                    })
    var ingEgre = -1;
    for(var i = 0; i < this.arrArbol.length; i++){
        ingEgre = this.arrArbol[i].tipo == "INGRESO" ? 0 : 1;
        if(i == 0){                                                          //--> PRIMER CONCEPTO
            this.fnAgregaNodoN1(this.arrArbol[i], ingEgre);
            if(this.arrArbol[i].idN2 != null){
                this.fnAgregaNodoN2(this.arrArbol[i], ingEgre)
                if(this.arrArbol[i].idN3 != null){
                    this.fnAgregaNodoN3(this.arrArbol[i], ingEgre)
                }
            }
        }
        else{                                                               //--> RESTO
            //console.log(this.arrArbol[i].idN1 + " != " + this.arrArbol[i-1].idN1);
            if(this.arrArbol[i].idN1 != this.arrArbol[i-1].idN1){                //--> VALIDAR QUE NO EXISTA EL CONCEPTO (N1)
                this.fnAgregaNodoN1(this.arrArbol[i], ingEgre);
                if(this.arrArbol[i].idN2 != null){
                    this.fnAgregaNodoN2(this.arrArbol[i], ingEgre)
                    if(this.arrArbol[i].idN3 != null){
                        this.fnAgregaNodoN3(this.arrArbol[i], ingEgre)
                    }
                }    
            }
            else{
                if(this.arrArbol[i].idN2 != this.arrArbol[i-1].idN2){                //--> VALIDAR QUE NO EXISTA EL SUBCONCEPTO (N2)
                    this.fnAgregaNodoN2(this.arrArbol[i], ingEgre)
                    if(this.arrArbol[i].idN3 != null){
                        this.fnAgregaNodoN3(this.arrArbol[i], ingEgre)
                    }
                }
                else{
                    if(this.arrArbol[i].idN3 != null){
                        this.fnAgregaNodoN3(this.arrArbol[i], ingEgre) 
                    }                  
                }    
            }                
        }
        
    }
    console.log(this.arbol)
  }

  fnAgregaNodoN1(item:any, ingEgre){
    this.arbol[ingEgre].conceptos.push({'idN1': item.idN1,
                                        'actN1': item.actN1,
                                        'padre': item.tipo,
                                        'concepto': item.concepto,
                                        'lblConcepto': item.lblConcepto,
                                        'subconceptos':[],
                                        'preCarga': item.preCarga == "SI" ? true : false,
                                        'ver': false,
                                        'total': 0
                                      })
  }

  fnAgregaNodoN2(item:any, ingEgre){
    this.arbol[ingEgre].conceptos[this.arbol[ingEgre].conceptos.length - 1].subconceptos.push({'idN2': item.idN2,
                                                  'actN2': item.actN2,
                                                  'tipo': item.tipo,
                                                  'padre': item.concepto,
                                                  'subconcepto': item.subconcepto,
                                                  'lblSubconcepto': item.lblSubconcepto,
                                                  'nota': item.nota,
                                                  'detalles':[],
                                                  'ver': false,
                                                  'total': 0
                                                })  
  }

  fnAgregaNodoN3(item:any, ingEgre){
    var auxIndex = this.arbol[ingEgre].conceptos[this.arbol[ingEgre].conceptos.length - 1].subconceptos.length;
    console.log(auxIndex);
    this.arbol[ingEgre].conceptos[this.arbol[ingEgre].conceptos.length - 1].subconceptos[auxIndex - 1].detalles.push({'idN3': item.idN3,
                                                            'actN3': item.actN3,
                                                            'tipo': item.tipo,
                                                            'abuelo': item.concepto,
                                                            'padre': item.subconcepto,
                                                            'detalle': item.detalle,
                                                            'total': 0
                                                          })  
  }

  fnMostrar(item){
    if(item.ver){
      item.ver = false;
    }
    else{
      item.ver = true;
    }
  }


  fnEditar(nivel, item){
    //console.log("Editar: " + mon.idMon);
    let dialogRef = this.dialog.open(PresConceptosEditComponent, {
                                      width: "600px",
                                      data: { 
                                            nivel:nivel,
                                            id: nivel == 1 ? item.idN1 : (nivel == 2 ? item.idN2 :  item.idN3),
                                            item:item
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    console.log("Popup cerrado");
                                    //this.fnInicio();
                                    }); 
  }

}
